export default "__VITE_ASSET__uCCpXmi0__"